import React, { useState } from "react";
import {
    ContentHeader,
    ContentTitleBlock,
    Chip,
    Subtitle,
    ContentActionsRow,
    BtnIcon,
    TabsNav,
    Tab
} from "../../components/SharedPageStyles";
import { SECTIONS } from "../../constants/sections";

import BreadthSentimentTab from "../economic-calendar/tabs/BreadthSentimentTab";
import RiskRegimeTab from "../economic-calendar/tabs/RiskRegimeTab";
import YieldsTab from "../economic-calendar/tabs/YieldsTab";
import SeasonalityTab from "../economic-calendar/tabs/SeasonalityTab";
import PositioningTab from "../economic-calendar/tabs/PositioningTab";
import FlowTab from "../economic-calendar/tabs/FlowTab";
import LiquidityTab from "../economic-calendar/tabs/LiquidityTab";
import RatesPricingTab from "../economic-calendar/tabs/RatesPricingTab";

import { MarketInternalsProvider, useMarketInternalsData } from "../../context/MarketInternalsContext";
import ExportButton from "../../components/ExportButton";

const MarketInternalsBoardContent = () => {
    const [activeTab, setActiveTab] = useState(SECTIONS["market-internals"].tabs[0].key);
    const { resetData, rows, isLoading } = useMarketInternalsData();

    const renderTabContent = () => {
        switch (activeTab) {
            case "breadth-sentiment": return <BreadthSentimentTab />;
            case "risk-regime": return <RiskRegimeTab />;
            case "yields": return <YieldsTab />;
            case "seasonality": return <SeasonalityTab />;
            case "positioning": return <PositioningTab />;
            case "flow": return <FlowTab />;
            case "liquidity": return <LiquidityTab />;
            case "rates-pricing": return <RatesPricingTab />;
            default: return <YieldsTab />;
        }
    };

    return (
        <>
            <ContentHeader>
                <ContentTitleBlock>
                    <Chip>Market Internals</Chip>
                    <Subtitle><em>Deep dive into market mechanics and internal data.</em></Subtitle>
                </ContentTitleBlock>
            </ContentHeader>

            <ContentActionsRow>
                <BtnIcon
                    aria-label="Refresh data"
                    onClick={resetData}
                    title="Refresh data"
                    disabled={isLoading}
                    $spinning={isLoading}
                >
                    ⟳
                </BtnIcon>
                <ExportButton data={rows} filename="market_internals" />
            </ContentActionsRow>

            <TabsNav>
                {SECTIONS["market-internals"].tabs.map(tab => (
                    <Tab
                        key={tab.key}
                        active={activeTab === tab.key}
                        onClick={() => setActiveTab(tab.key)}
                    >
                        {tab.label}
                    </Tab>
                ))}
            </TabsNav>

            {renderTabContent()}
        </>
    );
};

const MarketInternalsBoard = () => {
    return (
        <MarketInternalsProvider>
            <MarketInternalsBoardContent />
        </MarketInternalsProvider>
    );
};

export default MarketInternalsBoard;
